import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { UserData } from "../AppRoutes";
import AcademicYear from "../../pages/main-pages/super-admin/AcademicYear/list/AcademicYearList";
import RewardTypeList from "../../pages/main-pages/super-admin/reward-type/list/RewardTypeList";

interface superAdminProps {
  setIsAuthenticated: React.Dispatch<React.SetStateAction<UserData | null>>;
}

const SuperAdmin_Routes: React.FC<superAdminProps> = ({
  setIsAuthenticated,
}) => {
  const MainPage = React.lazy(() => import("../../pages/main-pages/MainPage"));
  const AdminsList = React.lazy(
    () => import("../../pages/main-pages/super-admin/admins/list/AdminList"),
  );
  const AcademiYear = React.lazy(
    () =>
      import("../../pages/main-pages/super-admin/AcademicYear/list/AcademicYearList"),
  );
  const Employees = React.lazy(
    () =>
      import("../../pages/main-pages/super-admin/employees/list/EmployeeList"),
  );
  const Students = React.lazy(
    () =>
      import("../../pages/main-pages/super-admin/students/list/StudentsList"),
  );
  const VpCodes = React.lazy(
    () =>
      import("../../pages/main-pages/super-admin/vp-codes/list/VpCodesList"),
  );
  const DepartMent = React.lazy(
    () =>
      import("../../pages/main-pages/super-admin/depatment/list/DepartmentList"),
  );

  const DtsAcademicYear = React.lazy(
    () =>
      import("../../pages/main-pages/super-admin/plc-academic-year/list/AcademicYearList"),
  );

  return (
    <Suspense>
      <Routes>
        <Route
          path="/"
          element={<MainPage setIsAuthenticated={setIsAuthenticated} />}
        >
          <Route index element={<Navigate to="admins" replace />} />
          <Route path="admins" element={<AdminsList />} />
          <Route path="academic-year" element={<AcademiYear />} />
          <Route path="employees" element={<Employees />} />
          <Route path="students" element={<Students />} />
          <Route path="vp-codes" element={<VpCodes />} />
          <Route path="department" element={<DepartMent />} />
          <Route path="reward-type" element={<RewardTypeList />} />
          <Route path="plc-academic-year" element={<DtsAcademicYear />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default SuperAdmin_Routes;
